import { Plus } from "lucide-react";

import { useIsPhysician } from "@src/features/physicians";
import { Button } from "@src/shared/components/ui/button";

import { CreatePatientPopoverV2 } from "../../../components/v2/CreatePatientPopover";
import { PatientsListV2 } from "../../../components/v2/PatientsList";

export function PatientsPageV2() {
  const canCreatePatient = useIsPhysician();

  return (
    <div className="mx-auto min-h-full w-full max-w-[860px] bg-background px-[18px] pb-8 pt-4">
      <div className="mb-3 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h1 className="text-[19px] font-semibold leading-tight tracking-[-0.015em] text-surface-foreground">
            Patients
          </h1>
          <p className="mt-1 text-[13px] leading-5 text-muted-foreground">
            Search your patients, or add a new one.
          </p>
        </div>
        <CreatePatientPopoverV2
          align="end"
          canCreatePatient={canCreatePatient}
          trigger={
            <Button
              type="button"
              size="sm"
              className="h-8 shrink-0 rounded-[9px] px-3 text-[12.5px] font-semibold shadow-none"
            >
              <Plus className="size-4" aria-hidden="true" />
              Add patient
            </Button>
          }
        />
      </div>
      <PatientsListV2 canCreatePatient={canCreatePatient} />
    </div>
  );
}
